import React from 'react';
import {Route} from 'react-router-dom';
import Async from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <Route
    key="/consumer/highlight/ymk"
    element={<DefaultConsumerLayout />}
  >
    <Route path="consumer/highlight/ymk" element={<Async />} />
  </Route>,
];
